import session from '../../../../share/session';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../share/util/api/polling';
import { PHASE, CHECK_ROUTINE_RESULT_TYPE } from './constants';
import { monitoring } from './monitoring';

/** 
 * 通常停止処理
 * @param {instance} self 呼び出し元インスタンス
 * @param {string} checkRoutineData ルーチン結果確認の返り値
 */
export async function stop(self, checkRoutineData) {
  try {
    self.isLoading = true;

    // バックエンドAPI POST,GET
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        type: 'stop'
      },
      // エラー発生のコールバックを実装
      // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
      async (result) => { await self.validateErrorResult(result); },
    );

    if (!response) return;

    // 中断の場合、結果に関わらず通信エラーに遷移
    if (checkRoutineData === CHECK_ROUTINE_RESULT_TYPE.OTHER) {
      self.phase = PHASE.COMMUNICATION_ERROR;
      return;
    }

    switch (response.data.status) {
      case REQUEST_STATUS_COMPLETED:
        // 正常終了：停止監視処理へ遷移
        await monitoring(self, checkRoutineData);
        break;
      case REQUEST_STATUS_FAILED:
        // 異常終了：通信エラーへ遷移
        self.phase = PHASE.COMMUNICATION_ERROR;
        break;
      default:
        await self.showUnexpectedError();
        break;
    }
  } finally {
    self.isLoading = false;
  }
}

